import React from 'react';
import { css } from '@emotion/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import BarLoader from 'react-spinners/BarLoader';

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'center',
    justifyContent: 'center',
    padding: '8rem',
  },
}));

const Loader = ({loading=true}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <BarLoader
        width={300}
        height={20}
        css={override}
        loading={loading}
        color={'#21bfaf'}
      />
    </div>
  );
};

Loader.propTypes = {
  loading: PropTypes.bool
};

export default Loader;
